/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TipoPraticaOperatoreStatoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetStatoTipoPraticaOperatoreRequestParams {
    idTipoPratica: string;
}


export interface TipoPraticaStatoBandoOperatoreServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Ritorna titolo, stato e visualizzazione del bando per l\&#39;audience operatore. State-agnostic (IN_ATTESA e ARCHIVIATA inclusi) e senza gate di visualizzazione: e\&#39; il gemello backoffice dello stato cittadino, che invece risponde 404 sui bandi non PUBBLICA. 404 se il bando non esiste, 403 se il chiamante non ha scope su di esso.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/stato-bando
* @param requestParameters
     */
    getStatoTipoPraticaOperatore(requestParameters: GetStatoTipoPraticaOperatoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaOperatoreStatoDTO>;

}
